import makeId from "../helpers/make-id.js";
import BattleActions from "./battle-data/battle-actions.js";

/** Take in the three inputs and return a formatted string that can be extracted */
export function encodeCloudQueueActionString(action) {
  //Unite targets into a stringified array
  const targetIds = action.target.join(",");

  //Provide a (hopefully) unique identifier for this string.
  //This is only to ensure two duplicates will not be confused in `indexOf` usage when master is determining the next selecting character
  const randomCharactersForUniqueness = makeId("cqId", 10);

  return `cloudQueueAction::${action.actionId}::${action.casterId}::[${targetIds}]::${randomCharactersForUniqueness}`;
}

/** Extract and assemble data from a cloudQueueActionString string. Returning something that can be used to submitAction */
export function decodeCloudQueueActionString(string, combatants = {}) {
  const dataFromString = string.split("::");
  const actionId = dataFromString[1];
  const casterId = dataFromString[2];
  const targetIdsArray = dataFromString[3]
    .replace("[", "")
    .replace("]", "")
    .split(",");

  return {
    actionModel: {
      id: actionId, //Include copy of the ID
      ...BattleActions[actionId] //Reference to the action.
    },
    casterModel: combatants[casterId], //me
    targetModels: targetIdsArray.map(targetId => combatants[targetId]) //my targets
  };
}



// WEBPACK FOOTER //
// ./src/battle/cloud-queue-encode-decode.js